import { Add, Remove } from "@mui/icons-material";
import { IconButton, List, useTheme } from "@mui/material";
import { Profile } from "@readyfit-common/models";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectCurrentUser } from "src/store/reducers/auth/authSlice";
import {
  selectShowDrawer,
  toggleDrawer,
} from "src/store/reducers/navigation/navigationSlice";
import useStyles from "./AppDrawer.styles";
import NavigationLink from "./NavigationLink";
import { NavLink, getBottomLinks, standardLinks } from "./links";

const Links = () => {
  const showDrawer = useAppSelector(selectShowDrawer);
  const classes = useStyles(showDrawer)();
  return (
    <List
      dense
      component={"nav"}
      className={!showDrawer ? classes.nav : undefined}
    >
      {standardLinks.map((link: NavLink, i: number) => (
        <NavigationLink key={`${link.name}-${i}`} link={link} />
      ))}
    </List>
  );
};

const BottomLinks = () => {
  const showDrawer = useAppSelector(selectShowDrawer);
  const classes = useStyles(showDrawer)();
  const profile: Profile = useAppSelector(selectCurrentUser);
  const bottomLinks = getBottomLinks(profile?.unreadMessagesCount || 0);
  return (
    <List dense component={"nav"} className={classes.bottomLinks}>
      {bottomLinks.map((link: NavLink, i: number) => (
        <NavigationLink key={`${link.name}-${i}`} link={link} />
      ))}
    </List>
  );
};

const AppDrawer = () => {
  const theme = useTheme();
  const showDrawer = useAppSelector(selectShowDrawer);
  const classes = useStyles(showDrawer)();
  const dispatch = useAppDispatch();

  return (
    <nav className={classes.root}>
      <IconButton
        className={classes.toggleButton}
        onClick={() => {
          dispatch(toggleDrawer());
        }}
      >
        {showDrawer ? (
          <Remove style={{ fill: theme.palette.secondary.light }} />
        ) : (
          <Add style={{ fill: theme.palette.secondary.light }} />
        )}
      </IconButton>

      {showDrawer ? (
        <>
          <img
            src="/logo_white_background.png"
            style={{
              objectFit: "contain",
              width: "110px",
              height: "56px",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: theme.spacing(7),
              marginBottom: theme.spacing(2),
            }}
            alt="readyfit-logo"
          />
        </>
      ) : (
        <img
          src="/mini_logo_white_background.png"
          alt="mini_logo_white_background"
          style={{
            objectFit: "contain",
            width: "56px",
            height: "26px",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: theme.spacing(7),
            marginBottom: theme.spacing(7),
          }}
        />
      )}

      <Links />

      <BottomLinks />
    </nav>
  );
};

export default AppDrawer;
